var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachinesSideBarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 24H9.5C8.67 24 8 23.33 8 22.5V9.5C8 8.67 8.67 8 9.5 8H22.5C23.33 8 24 8.67 24 9.5V22.5C24 23.33 23.33 24 22.5 24ZM9.5 9C9.22 9 9 9.22 9 9.5V22.5C9 22.78 9.22 23 9.5 23H22.5C22.78 23 23 22.78 23 22.5V9.5C23 9.22 22.78 9 22.5 9H9.5Z",
    fill: "#201E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.5C13.52 20.5 11.5 18.48 11.5 16C11.5 13.52 13.52 11.5 16 11.5C18.48 11.5 20.5 13.52 20.5 16C20.5 18.48 18.48 20.5 16 20.5ZM16 12.5C14.07 12.5 12.5 14.07 12.5 16C12.5 17.93 14.07 19.5 16 19.5C17.93 19.5 19.5 17.93 19.5 16C19.5 14.07 17.93 12.5 16 12.5Z",
    fill: "#201E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachinesSideBarIcon);
export default __webpack_public_path__ + "static/media/machinesSideBarIcon.15d76aeb18353e1bf44d0474cc0ab97d.svg";
export { ForwardRef as ReactComponent };